// Divider block schema - Section separator
export const dividerSchema = {
  type: 'divider',
  label: 'Divider',
  description: 'Horizontal line separator between sections',
  icon: 'Minus',
  defaultContent: {
    dividerStyle: 'line', // 'line' | 'dotted' | 'gradient' | 'space'
    width: 'medium', // 'narrow' | 'medium' | 'wide' | 'full'
    spacing: 'normal', // 'compact' | 'normal' | 'large'
    color: 'default', // 'default' | 'accent' | 'subtle'
    style: {},
  },
  fields: [
    {
      name: 'dividerStyle',
      label: 'Style',
      type: 'select',
      options: [
        { value: 'line', label: 'Solid Line' },
        { value: 'dotted', label: 'Dotted' },
        { value: 'gradient', label: 'Gradient Fade' },
        { value: 'space', label: 'Spacer Only' },
      ],
    },
    {
      name: 'width',
      label: 'Width',
      type: 'select',
      options: [
        { value: 'narrow', label: 'Narrow' },
        { value: 'medium', label: 'Medium' },
        { value: 'wide', label: 'Wide' },
        { value: 'full', label: 'Full Width' },
      ],
    },
    {
      name: 'spacing',
      label: 'Spacing',
      type: 'select',
      options: [
        { value: 'compact', label: 'Compact' },
        { value: 'normal', label: 'Normal' },
        { value: 'large', label: 'Large' },
      ],
    },
    {
      name: 'color',
      label: 'Color',
      type: 'select',
      options: [
        { value: 'default', label: 'Default (Gray)' },
        { value: 'accent', label: 'Accent (Green)' },
        { value: 'subtle', label: 'Subtle' },
      ],
    },
  ],
};
